import React from 'react'

interface IProps extends React.HTMLAttributes<HTMLSpanElement> {
    id?: string
    className?: string
    onClick?: React.MouseEventHandler<HTMLParagraphElement>
}

const Span: React.FC<IProps> = ({id, className, onClick, children, ...props}) => {
    return (
        <span
            id={id}
            className={`font-sans ${className} antialiased whitespace-pre-wrap`}
            onClick={onClick}
            suppressHydrationWarning={true}
            {...props}>
            {children as string}
        </span>
    )
}

export default Span
